import Vue from 'vue'
import App from './App'
import router from './router'

import {ChatComponent} from 'chat-component';


require('chat-component/dist/chat-component.css')

Vue.component('ChatComponent', ChatComponent);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js